import { t } from '@avalara/bat-apps-shared/i18n';
import { SAccordionContained, SAccordionStacked } from '@avalara/skylab-sdk/react';
import '../product-catalog.css';

import type { TranslationKey } from '@avalara/bat-apps-shared/i18n';
import type { ProductDetailSection, ProductFaq } from '../../../../../types/product-detail';

type Props = {
  faqs: ProductDetailSection<ProductFaq>;
};

const ProductDetailFaqSection = ({ faqs: { heading, description, items } }: Props) => {
  if (!items.length) return null;

  return (
    <div className='product-detail-faq-section' data-ref='buy.product-detail.faq-section'>
      <SAccordionContained data-ref='buy.product-detail.faq-section.accordion'>
        <div slot='title'>
          <h2>{heading ? t(heading as TranslationKey) : t('client.product-detail.faq-heading')}</h2>
          {description && (
            <span className='subtitle' data-ref='buy.product-detail.faq-section.subheading'>
              {t(description as TranslationKey)}
            </span>
          )}
        </div>
        {items.map(({ question, answer }, index) => (
          <SAccordionStacked
            key={question}
            id={`buy-product-detail-faq-${index}`}
            data-ref={`buy.product-detail.faq-section.item.${index}`}
          >
            <span slot='title'>{t(question as TranslationKey)}</span>
            <div>{t(answer as TranslationKey)}</div>
          </SAccordionStacked>
        ))}
      </SAccordionContained>
    </div>
  );
};

export default ProductDetailFaqSection;
